








import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryUserCheckinRecordList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { CheckinRecordStatusFormat } from '@/utils/tyepconvert'
import constant from '@/utils/constant'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class UserCheckinRecordList extends Vue {
  private queryParam: any = {
    startRow: 1,
    limit: 10,
    checkinDateDaterange: [],
    createTimeDaterange: [],
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  private queryModels: Array<QueryModel> = [
    { title: '用户ID', param: 'userId' },
    { title: '用户名称', param: 'userName' },
    { title: '状态', param: 'status', type: 'select', selectData: constant.CheckinRecordStatus },
    { title: '签到日期', param: 'checkinDateDaterange', type: 'daterange' },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange' },
  ]

  private queryOperation: Array<TableOperation> = []

  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '用户ID', param: 'userId', width: 100 },
    { title: '用户名称', param: 'userName', width: 120 },
    { title: '手机号', param: 'mobilePhone', width: 120 },
    { title: '签到日期', param: 'checkinDate', width: 120, formatter: DateFormat },
    { title: '连续天数', param: 'streakDays', width: 80 },
    { title: '基础活跃', param: 'baseActivityQty' },
    { title: '倍率', param: 'ladderMultiplier' },
    { title: '本次总活跃', param: 'activityQty' },
    { title: '特殊奖ID', param: 'specialRewardId', width: 90 },
    { title: '贡献', param: 'contributionQty' },
    { title: '能量', param: 'energyQty' },
    { title: '绿豆', param: 'mungBeanQty' },
    { title: '积分', param: 'pointsQty' },
    { title: '状态', param: 'status', formatter: CheckinRecordStatusFormat, width: 90 },
    { title: '创建时间', width: 160, param: 'createTime', formatter: DateFormat },
    { title: '备注', param: 'note', overflow: true },
  ]

  public activated() {
    this.loadData()
  }

  public async created() {
    this.loadData()
  }

  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryUserCheckinRecordList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam() {
    const param: any = { ...this.queryParam }
    if (param.checkinDateDaterange && param.checkinDateDaterange.length > 0) {
      param.checkinDateRange = DateFormat(param.checkinDateDaterange[0]) + ',' + DateFormat(param.checkinDateDaterange[1])
    }
    if (param.createTimeDaterange && param.createTimeDaterange.length > 0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 12)
    return param
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }

  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
